import { categories } from '@/mocks/categories';

const featuredCategories = [
  {
    name: 'Shoes',
    url: 'https://kaspreadsheet.com/category-911-Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20premium%20sneaker%20display%20on%20light%20cream%20marble%20surface%20three%20different%20athletic%20shoe%20styles%20arranged%20with%20artistic%20composition%20soft%20natural%20window%20lighting%20clean%20minimalist%20aesthetic%20professional%20product%20photography%20warm%20neutral%20tones%20sophisticated%20editorial%20presentation&width=800&height=600&seq=cat-shoes-v2-2026&orientation=landscape',
    label: 'Tênis',
  },
  {
    name: 'Hoodies/Sweaters',
    url: 'https://kaspreadsheet.com/search-912/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20hoodie%20fashion%20flat%20lay%20photography%20with%20two%20premium%20cotton%20sweatshirts%20neatly%20folded%20on%20light%20cream%20textured%20surface%20soft%20diffused%20natural%20light%20modern%20streetwear%20aesthetic%20editorial%20quality%20composition%20warm%20neutral%20palette%20clean%20presentation&width=800&height=600&seq=cat-hoodies-v2-2026&orientation=landscape',
    label: 'Moletom',
  },
  {
    name: 'T-Shirts',
    url: 'https://kaspreadsheet.com/search-913/name/Shoes.html',
    image: 'https://readdy.ai/api/search-image?query=Clean%20fashion%20photography%20of%20premium%20cotton%20t-shirts%20folded%20elegantly%20on%20light%20cream%20surface%20with%20subtle%20plant%20accent%20soft%20natural%20morning%20light%20modern%20minimalist%20style%20professional%20editorial%20composition%20warm%20neutral%20tones%20sophisticated%20casual%20aesthetic&width=800&height=600&seq=cat-tshirts-v2-2026&orientation=landscape',
    label: 'Camisetas',
  },
];

const pillImages: Record<string, string> = {
  'Jackets': 'https://readdy.ai/api/search-image?query=Closeup%20detail%20of%20premium%20stylish%20jacket%20fabric%20texture%20on%20light%20cream%20background%20soft%20natural%20light%20minimalist%20product%20detail%20shot%20warm%20neutral%20tones%20clean%20professional%20aesthetic&width=120&height=120&seq=pill-jackets-2026&orientation=squarish',
  'Pants/Shorts': 'https://readdy.ai/api/search-image?query=Closeup%20detail%20of%20premium%20quality%20casual%20pants%20denim%20fabric%20neatly%20folded%20on%20light%20cream%20surface%20soft%20natural%20light%20minimalist%20closeup%20product%20shot%20warm%20tones%20clean%20aesthetic&width=120&height=120&seq=pill-pants-2026&orientation=squarish',
  'Headwear': 'https://readdy.ai/api/search-image?query=Elegant%20premium%20baseball%20cap%20with%20subtle%20embroidery%20detail%20on%20light%20cream%20background%20closeup%20product%20photography%20soft%20natural%20lighting%20minimalist%20aesthetic%20warm%20neutral%20tones%20professional%20detail%20shot&width=120&height=120&seq=pill-headwear-2026&orientation=squarish',
  'Sets': 'https://readdy.ai/api/search-image?query=Coordinated%20premium%20fashion%20set%20with%20matching%20top%20and%20bottom%20pieces%20neatly%20arranged%20on%20light%20cream%20surface%20soft%20natural%20light%20minimalist%20product%20photography%20warm%20neutral%20tones%20clean%20professional%20composition&width=120&height=120&seq=pill-sets-2026&orientation=squarish',
  'Underwear/Underpants': 'https://readdy.ai/api/search-image?query=Premium%20cotton%20underwear%20product%20detail%20elegantly%20folded%20on%20light%20cream%20surface%20soft%20natural%20lighting%20clean%20minimalist%20closeup%20shot%20warm%20neutral%20tones%20professional%20product%20photography%20subtle%20aesthetic&width=120&height=120&seq=pill-underwear-2026&orientation=squarish',
  'Jersey': 'https://readdy.ai/api/search-image?query=Premium%20sports%20jersey%20fabric%20texture%20closeup%20with%20subtle%20pattern%20detail%20on%20light%20cream%20background%20soft%20natural%20light%20minimalist%20product%20detail%20photography%20warm%20neutral%20tones%20professional%20clean%20aesthetic&width=120&height=120&seq=pill-jersey-2026&orientation=squarish',
  'Accessories': 'https://readdy.ai/api/search-image?query=Elegant%20fashion%20accessories%20including%20premium%20watch%20and%20bracelet%20arranged%20on%20light%20cream%20surface%20soft%20natural%20lighting%20clean%20minimalist%20closeup%20product%20photography%20warm%20neutral%20tones%20sophisticated%20aesthetic&width=120&height=120&seq=pill-accessories-2026&orientation=squarish',
  'Bags': 'https://readdy.ai/api/search-image?query=Premium%20minimalist%20backpack%20product%20detail%20closeup%20on%20light%20cream%20background%20soft%20natural%20light%20clean%20modern%20aesthetic%20subtle%20texture%20warm%20neutral%20tones%20professional%20product%20photography%20elegant%20composition&width=120&height=120&seq=pill-bags-2026&orientation=squarish',
  'Belts': 'https://readdy.ai/api/search-image?query=Elegant%20premium%20leather%20belt%20detail%20closeup%20with%20subtle%20buckle%20on%20light%20cream%20surface%20soft%20natural%20lighting%20minimalist%20product%20photography%20warm%20neutral%20tones%20professional%20clean%20aesthetic&width=120&height=120&seq=pill-belts-2026&orientation=squarish',
  'Perfumes': 'https://readdy.ai/api/search-image?query=Elegant%20premium%20perfume%20bottle%20closeup%20with%20subtle%20glass%20reflections%20on%20light%20cream%20background%20soft%20natural%20light%20minimalist%20product%20photography%20warm%20neutral%20tones%20sophisticated%20luxury%20aesthetic&width=120&height=120&seq=pill-perfumes-2026&orientation=squarish',
  'Other Stuff': 'https://readdy.ai/api/search-image?query=Curated%20collection%20of%20miscellaneous%20premium%20lifestyle%20accessories%20neatly%20arranged%20on%20light%20cream%20surface%20soft%20natural%20light%20clean%20minimalist%20product%20photography%20warm%20neutral%20tones%20eclectic%20aesthetic%20professional%20composition&width=120&height=120&seq=pill-other-2026&orientation=squarish',
};

const otherCategories = categories.filter(
  (c) => !['Shoes', 'Hoodies/Sweaters', 'T-Shirts'].includes(c.name)
);

export default function CategorySection() {
  return (
    <section className="bg-background-50 py-14 md:py-20 scroll-mt-20" id="categorias">
      <div className="w-full px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-4 mb-12 max-w-6xl mx-auto">
          <div>
            <h2 className="font-heading font-extrabold text-2xl md:text-4xl text-foreground-950 leading-tight">
              Navegue por<br />
              <span className="italic font-normal text-accent-600">Categoria</span>
            </h2>
          </div>
          <p className="text-sm text-foreground-600 max-w-md leading-relaxed">
            Explore as nossas categorias de produtos verificados. Cada link foi testado por
            compradores reais para garantir a melhor experiência no CSSBuy Spreadsheet.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6 max-w-6xl mx-auto mb-10">
          {featuredCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group block bg-background-50 rounded-2xl overflow-hidden hover:bg-accent-50 transition-colors duration-300 cursor-pointer"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={cat.image}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <div className="p-5">
                <span className="inline-block bg-accent-100 text-accent-700 text-xs font-semibold px-3 py-1 rounded-full mb-3">
                  {cat.label}
                </span>
                <h3 className="font-heading font-bold text-lg text-foreground-950 group-hover:text-accent-700 transition-colors">
                  {cat.name}
                </h3>
                <div className="flex items-center gap-2 mt-2 text-foreground-500 text-xs">
                  <span>Explorar produtos</span>
                  <span className="w-3.5 h-3.5 flex items-center justify-center">
                    <i className="ri-arrow-right-up-line text-[11px]"></i>
                  </span>
                </div>
              </div>
            </a>
          ))}
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-3 max-w-6xl mx-auto">
          {otherCategories.map((cat) => (
            <a
              key={cat.name}
              href={cat.url}
              target="_blank"
              rel="noopener nofollow"
              className="group flex flex-col items-center gap-2.5 bg-background-50 hover:bg-accent-50 rounded-2xl p-4 transition-colors duration-300 cursor-pointer"
            >
              <div className="w-16 h-16 md:w-20 md:h-20 rounded-xl overflow-hidden flex-shrink-0">
                <img
                  src={pillImages[cat.name] || ''}
                  alt={cat.name}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              <span className="text-xs font-medium text-foreground-700 text-center leading-tight whitespace-nowrap">
                {cat.name}
              </span>
              <span className="w-4 h-4 flex items-center justify-center text-foreground-400 group-hover:text-accent-600 transition-colors">
                <i className="ri-arrow-right-up-line text-[11px]"></i>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}